/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitFeatureListDto } from './KokpitFeatureListDto';
import {
    KokpitFeatureListDtoFromJSON,
    KokpitFeatureListDtoFromJSONTyped,
    KokpitFeatureListDtoToJSON,
} from './KokpitFeatureListDto';

/**
 * 
 * @export
 * @interface KokpitModuleListDto
 */
export interface KokpitModuleListDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitModuleListDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitModuleListDto
     */
    id?: number;
    /**
     * Ekleyenin Tam İsmi
     * @type {string}
     * @memberof KokpitModuleListDto
     */
    createdByFullName?: string | null;
    /**
     * Güncelleyenin Tam İsmi
     * @type {string}
     * @memberof KokpitModuleListDto
     */
    modifiedByFullName?: string | null;
    /**
     * Eklenme Tarihi
     * @type {Date}
     * @memberof KokpitModuleListDto
     */
    createdAt?: dayjs.Dayjs;
    /**
     * Güncelleme Tarihi
     * @type {Date}
     * @memberof KokpitModuleListDto
     */
    modifiedAt?: dayjs.Dayjs;
    /**
     * 
     * @type {string}
     * @memberof KokpitModuleListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitModuleListDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<KokpitFeatureListDto>}
     * @memberof KokpitModuleListDto
     */
    features?: Array<KokpitFeatureListDto> | null;
}

/**
 * Check if a given object implements the KokpitModuleListDto interface.
 */
export function instanceOfKokpitModuleListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitModuleListDtoFromJSON(json: any): KokpitModuleListDto {
    return KokpitModuleListDtoFromJSONTyped(json, false);
}

export function KokpitModuleListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitModuleListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdByFullName': !exists(json, 'createdByFullName') ? undefined : json['createdByFullName'],
        'modifiedByFullName': !exists(json, 'modifiedByFullName') ? undefined : json['modifiedByFullName'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (dayjs(json['createdAt'])),

        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (dayjs(json['modifiedAt'])),

        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'features': !exists(json, 'features') ? undefined : (json['features'] === null ? null : (json['features'] as Array<any>).map(KokpitFeatureListDtoFromJSON)),
    };
}

export function KokpitModuleListDtoToJSON(value?: KokpitModuleListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'createdByFullName': value.createdByFullName,
        'modifiedByFullName': value.modifiedByFullName,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'modifiedAt': value.modifiedAt === undefined ? undefined : (value.modifiedAt.toISOString()),
        'name': value.name,
        'description': value.description,
        'features': value.features === undefined ? undefined : (value.features === null ? null : (value.features as Array<any>).map(KokpitFeatureListDtoToJSON)),
    };
}

